// extracted by mini-css-extract-plugin
export default {"container":"EmailTemplate_container__v5rH2","dropdownAndVars":"EmailTemplate_dropdownAndVars__rR-LZ","requiredVars":"EmailTemplate_requiredVars__91BKC"};